import { Box, Stack, VStack } from "@chakra-ui/react";

export default function GreyBox({ children ,...props}) {
    return (
        <Stack
            m="0 0 20px 0"
            p="19px"
            bgColor="primary.bgGrey"
            border="1px solid"
            borderColor="primary.borderGrey"
            borderRadius="4px"
            boxShadow="inset 0 1px 1px rgba(0,0,0,.05)"  
            gap="20px"
            {...props}
        >
            {children}
        </Stack>
    )
}